module.exports = __webpack_public_path__ + "img/cover.2d337db6.png";